import $devices from 'app/stores/device/$devices';
import { getMetricsDeviceNameFromQueryModel } from 'app/stores/metrics/$metricsDevices';

/**
 * @param {string} [device_name]
 * @param {string} [device_ip]
 * @param {string} [mac_address]
 * @returns {import('app/stores/device/DeviceModel').DeviceModel | undefined}
 */
export const getDeviceFromMetricsQueryModel = ({ device_name, device_ip, mac_address }) => {
  const name = getMetricsDeviceNameFromQueryModel({ device_name, device_ip, mac_address });
  return $devices.byName(name);
};
